import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "@/shared/config/constants";
import { cn } from "@/shared/lib/utils";
import { LayoutDashboard, Gem, Users } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/ui/tooltip";

const menuItems = [
  {
    title: "Dashboard",
    href: ROUTES.DASHBOARD,
    icon: LayoutDashboard,
  },
  {
    title: "DDCs",
    href: ROUTES.DDCS,
    icon: Gem,
  },
  {
    title: "Users",
    href: ROUTES.USERS,
    icon: Users,
  },
];

interface SidebarContentProps {
  isExpanded?: boolean;
  showTooltips?: boolean;
  showHeader?: boolean;
}

export function SidebarContent({ isExpanded = true, showTooltips = false, showHeader = false }: SidebarContentProps) {
  const location = useLocation();

  return (
    <TooltipProvider delayDuration={0}>
      <div className="flex h-full flex-col">
        {showHeader && (
          <div className="flex h-16 items-center border-b px-4">
            <h2 className="text-lg font-semibold">Admin</h2>
          </div>
        )}
        <nav className="flex-1 space-y-1 p-4">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.href;
            const menuItem = (
              <Link
                to={item.href}
                className={cn(
                  "flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors",
                  isExpanded ? "justify-start" : "justify-center",
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
                )}
              >
                <Icon className="h-5 w-5 shrink-0" />
                {isExpanded && (
                  <span className="transition-opacity duration-300">{item.title}</span>
                )}
              </Link>
            );

            if (!isExpanded && showTooltips) {
              return (
                <Tooltip key={item.href}>
                  <TooltipTrigger asChild>{menuItem}</TooltipTrigger>
                  <TooltipContent side="right">
                    <p>{item.title}</p>
                  </TooltipContent>
                </Tooltip>
              );
            }

            return <div key={item.href}>{menuItem}</div>;
          })}
        </nav>
      </div>
    </TooltipProvider>
  );
}
